import { EMAIL_QUOTE_STYLE } from "@productlane/lib/src/html"

import { isEmptyContentTag } from "./index"

export { EMAIL_QUOTE_STYLE }

// The signature is never wrapped in a blockquote: it is the sender's own text,
// so it renders plain while only the quoted history carries the quote bar.
export const buildSignatureHtml = (signature: string | null | undefined) =>
	isEmptyContentTag(signature) ? "" : (signature ?? "")

export const wrapInQuote = (html: string) =>
	`<blockquote class="productlane-quote" style="${EMAIL_QUOTE_STYLE}">${html}</blockquote>`

// A blank line is an empty paragraph, in the composer and on the wire alike.
const BLANK_LINE = "<p></p>"

export const buildEmailHistoryHtml = ({
	signature,
	quotedContent,
}: {
	signature: string
	quotedContent: string
}) => {
	const blocks = [signature, quotedContent].filter(Boolean)
	if (blocks.length === 0) return ""
	return `<div data-email-history="true">${BLANK_LINE}${blocks.join(BLANK_LINE)}</div>`
}
